import getBannersForNodes from './get-banners-for-nodes';

export default getBannersForNodes;
